export default class CampaignParser {

    constructor(queryString) {
        this.params = new URLSearchParams(queryString.replace(/^\?/, ""));

        // Cargar la configuración global
        this.cfg = window.__pt.settings.site.campaignConversionConfiguration || {};
        this.trv = this.cfg.trivago || {};
        this.gha = this.cfg.googleHotelAds || {};
        this.kayak = this.cfg.kayak || {};
    }

    getParam(name) {
        return this.params.get(name);
    }

    has(name) {
        return this.params.has(name);
    }

    parse() {

        let result = {
            campaignType: "",
            campaignId: "",
            originId: "",
            providerReference: ""
        };

        const source = this.getParam("source") || "";

        // ------------------------------
        //            TRIVAGO
        // ------------------------------
        if (this.has("trv_reference") && this.has("source")) {

            result.campaignType = "Trivago";
            result.providerReference = this.getParam("trv_reference");
            result.originId = this.trv.originId ?? "";

            switch (source) {
                case "trivago-mx": result.campaignId = this.trv.mx; break;
                case "trivago-ptus": result.campaignId = this.trv.us; break;
                case "trivagoCL": result.campaignId = this.trv.cl; break;
                case "trivagoEC": result.campaignId = this.trv.ec; break;
                case "trivagoPE": result.campaignId = this.trv.pe; break;
                case "trivagoUY": result.campaignId = this.trv.uy; break;
                case "trivago-co": result.campaignId = this.trv.co; break;
                default: result.campaignId = this.trv.default; break;
            }
        }

        // ------------------------------
        //      GOOGLE HOTEL ADS
        // ------------------------------
        else if (this.has("gclid") && this.has("source")) {

            result.campaignType = "GoogleHotelAds";
            result.providerReference = this.getParam("gclid");

            switch (source) {
                case "google-ha-mx": result.campaignId = this.gha.mx; break;
                case "google-ha-usa": result.campaignId = this.gha.us; break;
                case "google-ha-usa-es": result.campaignId = this.gha.us; break;
                case "google-ha-pe": result.campaignId = this.gha.pe; break;
                case "google-ha-uy": result.campaignId = this.gha.uy; break;
                case "google-ha-cl": result.campaignId = this.gha.cl; break;
                case "google-ha-ec": result.campaignId = this.gha.ec; break;
                case "google-ha-ca": result.campaignId = this.gha.ca; break;
                case "google-ha-co": result.campaignId = this.gha.co; break;
                default: result.campaignId = this.gha.default; break;
            }
        }

        // ------------------------------
        //             KAYAK
        // ------------------------------
        else if (this.has("kayakclickid") && this.has("source")) {

            result.campaignType = "Kayak";
            result.providerReference = this.getParam("kayakclickid");

            switch (source) {
                case "kayak-mx": result.campaignId = this.kayak.mx; break;
                case "kayak-usa": result.campaignId = this.kayak.uS_EN; break;
                case "kayak-usa-es": result.campaignId = this.kayak.uS_ES; break;
                case "kayak-pe": result.campaignId = this.kayak.pe; break;
                case "kayak-co": result.campaignId = this.kayak.default; break;
                default: result.campaignId = this.kayak.default; break;
            }
        }

        return result;
    }
}
